<div class="offcanvas-header w-100">
  <h4 class="offcanvas-title" id="offcanvas-settings-title">Settings</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="offcanvas-body d-flex flex-column w-100">
  <div class="flex-grow-1 overflow-x-hidden overflow-y-auto">
    <!-- Tab Navigation -->
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3 border-bottom border-dark" [destroyOnHide]="false">
      <li [ngbNavItem]="'product-ordering'">
        <button ngbNavLink>Product Ordering</button>
        <ng-template ngbNavContent>
          <form>
            <app-planogram-levels
              [levels]="levels"
              (levelsChanged)="levels = $event">
            </app-planogram-levels>
          </form>
        </ng-template>
      </li>

      <li [ngbNavItem]="'drop-settings'">
        <button ngbNavLink>Drop Settings</button>
        <ng-template ngbNavContent>
          <form>
            <div class="row mb-3">
              <label for="targetDrops" class="col-sm-4 col-form-label">Target Drops</label>
              <div class="col-sm-8 d-flex gap-2 align-items-center">
                <input
                  type="number"
                  class="form-control"
                  id="targetDrops"
                  name="targetDrops"
                  [(ngModel)]="targetDrops"
                  step="1"
                  min="1"
                  [placeholder]="planogramService.getTargetDrops(true)" />
                
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  (click)="clearTargetDropsSetting()"
                  *ngIf="targetDrops !== null">
                  Reset
                </button>
              </div>
            </div>
            
            <div class="row mb-3">
              <label for="dropHeight" class="col-sm-4 col-form-label">Drop Height</label>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  id="dropHeight"
                  name="dropHeight"
                  [(ngModel)]="dropHeight"
                  step="1"
                  (input)="onDropHeightInput($event)"
                />
              </div>
            </div>
            
            <div class="row mb-3">
              <label for="dropDepth" class="col-sm-4 col-form-label">Drop Depth</label>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  id="dropDepth"
                  name="dropDepth"
                  [(ngModel)]="dropDepth"
                  step="1"
                  (input)="onDropDepthInput($event)"
                />
              </div>
            </div>
            
            <div class="row mb-3">
              <label for="footerHeight" class="col-sm-4 col-form-label">Base Height</label>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  id="footerHeight"
                  name="footerHeight"
                  [(ngModel)]="footerHeight"
                  step="1"
                  (input)="onFooterHeightInput($event)"
                />
              </div>
            </div>
            
            <div class="row mb-3">
              <label for="shelfWidth" class="col-sm-4 col-form-label">Shelf Width</label>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  id="shelfWidth"
                  name="shelfWidth"
                  [(ngModel)]="shelfWidth"
                  step="1"
                  (input)="onShelfWidthInput($event)"
                />
              </div>
            </div>
            
            <div class="row mb-3">
              <label for="shelfLipHeight" class="col-sm-4 col-form-label">Shelf Lip Height</label>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  id="shelfLipHeight"
                  name="shelfLipHeight"
                  [(ngModel)]="shelfLipHeight"
                  step="1"
                  (input)="onShelfLipHeightInput($event)"
                />
              </div>
            </div>
            
            <div class="row mb-3">
              <label for="shelfMinSpacing" class="col-sm-4 col-form-label">Shelf Minimum Spacing</label>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  id="shelfMinSpacing"
                  name="shelfMinSpacing"
                  [(ngModel)]="shelfMinSpacing"
                  step="1"
                  (input)="onShelfMinSpacingInput($event)"
                />
              </div>
            </div>
          </form>
        </ng-template>
      </li>

      <li [ngbNavItem]="'planogram-settings'">
        <button ngbNavLink>Planogram Settings</button>
        <ng-template ngbNavContent>
          <form>
            <div class="row mb-3">
              <div class="col-sm-10 offset-sm-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="applyOptimization"
                    name="applyOptimization"
                    [(ngModel)]="applyOptimization"
                  />
                  <label class="form-check-label" for="applyOptimization">
                    Apply Optimization
                  </label>
                </div>
              </div>
            </div>

            <div class="row mb-3 d-none">
              <div class="col-sm-10 offset-sm-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="maxStackOptimization"
                    name="maxStackOptimization"
                    [(ngModel)]="maxStackOptimization"
                    [disabled]="!applyOptimization"
                  />
                  <label class="form-check-label" for="maxStackOptimization">
                    Max Stack Optimization
                  </label>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-10 offset-sm-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="forceMaxStack"
                    name="forceMaxStack"
                    [(ngModel)]="forceMaxStack"
                  />
                  <label class="form-check-label" for="forceMaxStack">
                    Force Max Stack
                  </label>
                </div>
              </div>
            </div>
            
            <div class="row mb-3">
              <div class="col-sm-10 offset-sm-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="resetFacingsToMinDOS"
                    name="resetFacingsToMinDOS"
                    [(ngModel)]="resetFacingsToMinDOS"
                  />
                  <label class="form-check-label" for="resetFacingsToMinDOS">
                    Reset Facings to Min DOS
                  </label>
                </div>
              </div>
            </div>
            
            <div class="row mb-3">
              <label for="dosRange" class="col-sm-4 col-form-label">DOS (Min/Max)</label>
              <div class="col-sm-8">
                <div class="d-flex gap-2 align-items-center">
                  <ngx-slider
                    [(value)]="dosMin"
                    [(highValue)]="dosMax"
                    [options]="dosSliderOptions">
                  </ngx-slider>
                  <button 
                    type="button" 
                    class="btn btn-outline-secondary btn-sm"
                    (click)="openDosOverride()">
                    Override
                  </button>
                </div>
              </div>
            </div>
            
            <div class="row mb-3">
              <label class="col-sm-4 col-form-label">CPI Thresholds</label>
              <div class="col-sm-8">
                <div class="row mb-2">
                  <div class="col-4">
                    <label for="cpiTier1" class="form-label text-danger">Red (≤)</label>
                    <input
                      type="number"
                      class="form-control"
                      id="cpiTier1"
                      name="cpiTier1"
                      [(ngModel)]="cpiTier1"
                      step="1"
                      min="0"
                    />
                  </div>
                  <div class="col-4">
                    <label for="cpiTier2" class="form-label text-warning">Orange (≤)</label>
                    <input
                      type="number"
                      class="form-control"
                      id="cpiTier2"
                      name="cpiTier2"
                      [(ngModel)]="cpiTier2"
                      step="1"
                      min="0"
                    />
                  </div>
                  <div class="col-4">
                    <label for="cpiTier3" class="form-label text-secondary">Yellow (≤)</label>
                    <input
                      type="number"
                      class="form-control"
                      id="cpiTier3"
                      name="cpiTier3"
                      [(ngModel)]="cpiTier3"
                      step="1"
                      min="0"
                    />
                  </div>
                </div>
                <small class="form-text text-muted">Green will be values > Yellow threshold</small>
              </div>
            </div>
          </form>
        </ng-template>
      </li>
    </ul>
    
    <div [ngbNavOutlet]="nav" class="mt-2 p-2"></div>
  </div>

  <!-- Footer with buttons -->
  <div class="mt-3 pt-3 border-top">
    <div class="d-flex w-100 gap-2 flex-wrap">
      <button
        type="button"
        class="btn flex-fill btn-primary"
        (click)="saveSettings()">
        Save
      </button>
      <button
        *hasCapability="CapabilityType.APPROVE_PLANOGRAM"
        type="button"
        class="btn flex-fill btn-success"
        (click)="approvePlanogram()">
        Approve Planogram
      </button>
      <button
        type="button"
        class="btn flex-fill btn-secondary"
        (click)="saveDefaultSettings()">
        Set Merch Default
      </button>
      <button type="button" class="btn flex-fill btn-warning" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
</div>